import { Injectable } from '@angular/core';
import { Response, URLSearchParams } from '@angular/http';
import { Angular2TokenService } from 'angular2-token';
import { Store } from "@ngrx/store";
import { AppState } from "@store/app-state";
import { Role } from "@models/role";
import { Observable } from 'rxjs';
import { User } from "@models/user";

@Injectable()
export class RoleService {

  private rolesUrl: string = 'roles'
  private usersUrl: string = 'users'

  constructor(
    private http: Angular2TokenService,
    private store: Store<AppState>,
  ) {}

  index(params: any): Observable<Role[]> {
    return this.http.get(this.rolesUrl)
      .map((res: Response) => res.json().map((r: any) => Role.clone(r)))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  updateUser(user: any): Observable<User> {
    return this.http.patch(`${this.usersUrl}/${user.id}`, user)
      .map((res: Response) => User.clone(res.json()))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  roleUsers(roleId: number): Observable<User[]> {
    return this.http.get(`${this.rolesUrl}/${roleId}/users`)
      .map((res: Response) => res.json().map((u: any) => User.clone(u)))
      .catch((error: Response) => Observable.throw(error.json()))
  }
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/services/role.ts